import {
  Description,
  Field,
  Label,
  Textarea as TextareaComponent,
} from "@headlessui/react";
import clsx from "clsx";

const Textarea = ({
  label,
  description,
  rows = 3,
  className,
  value,
  onChange,
  ...props
}) => {
  return (
    <div className="w-full">
      <Field>
        <Label className="text-sm font-medium text-gray-700 pl-1">{label}</Label>
        <Description className="text-sm text-gray-400">
          {description}
        </Description>
        <TextareaComponent
          className={clsx(
            "mt-2 block w-full resize-none rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-[#0B1120]",
            "focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 focus:outline-none",
            "placeholder:text-gray-400 transition-all duration-300",
            className
          )}
          rows={rows}
          value={value}
          onChange={onChange}
          {...props}
        />
      </Field>
    </div>
  );
};

export default Textarea;
